export default __webpack_public_path__ + "static/icon-spacing-dark-ed4bc9ef5e7fa807c066f6de204d7748.png";